// extracted by mini-css-extract-plugin
export default {"ViewLayout":"viewLayout_ViewLayout__wI3-R"};